import React from 'react';

import {generateComponentCallback} from '/util/component.util';

// TODO: Handle the following conditions:
// {minSinceRefresh>60 && minSinceRefresh<120} and {minSinceRefresh>120}
// to show "1 hour ago" and "N hours ago"

export const refreshText = ({minSinceRefresh, tt}: any) => {
  let text = '';

  if (minSinceRefresh < 1) {
    text = tt('justNow', 'just now');
  } else if (minSinceRefresh === 1) {
    text = tt('minuteAgo', '1 minute ago');
  } else if (minSinceRefresh > 1) {
    text = tt(
      'minutesAgo',
      generateComponentCallback({
        component: <>{minSinceRefresh} minutes ago</>,
      }),
    );
  }

  return text;
};
